import PropTypes from 'prop-types';
import cn from 'classnames';
import format from 'date-fns/format';
import common from 'constants/common';
import logo from 'assets/img/logo.svg';

const GeneralComment = ({ id, comment, solid }) => {
  const {
    createdByTitle,
    createdByFirstName,
    createdByLastName,
    createdByProfessionType,
    message,
    createdAt,
  } = comment;
  return (
    <tr className={cn({ 'no-strip': solid })}>
      <td className="col-1 text-center">{id}</td>
      <td className="col-8 comment">
        <strong>General Comments</strong>
        <span className="comment__msg non-capitalized">{message}</span>
        <span>
          By: {createdByTitle} {createdByFirstName} {createdByLastName}
          {createdByProfessionType ? ' - ' : ' '}
          {createdByProfessionType}
        </span>
      </td>
      <td className="col-3 info">
        <img src={logo} alt="Comment logo" />
        <span>
          {createdAt
            ? format(new Date(createdAt), common.dateFormats.dateAndTime)
            : ''}
        </span>
        {comment.commentType && (
          <span
            className="comment-type"
            style={{
              marginBottom: '0px',
              display: 'inline-flex',
              textTransform: 'uppercase',
            }}
          >
            {comment.commentType}
          </span>
        )}
      </td>
    </tr>
  );
};

GeneralComment.propTypes = {
  comment: PropTypes.shape().isRequired,
  id: PropTypes.number,
  solid: PropTypes.bool,
};

export default GeneralComment;
